<template>
  <v-row justify="center">
    <v-dialog
      v-model="openDialog"
      persistent
      max-width="60%"
    >
      <v-card height="30vh"> 
        <v-card-title class="text-h5">
          Deshabilitar Dispositivo
        </v-card-title>
        <v-card-text class="text-h7">
        	Al presionar el botón de confirmación, <b>TODAS</b> las boletas <b>OFFLINE</b> que se reciban posterior a esta acción, serán rechazadas
        </v-card-text>
        <v-card-text>
			<v-simple-table>
			    <template v-slot:default>
			      <thead>
			        <tr>
			          <th class="text-left">
			            ID dispositivo
			          </th>
			          <th class="text-left">
			            Sistema Operativo
			          </th>
			          <th class="text-left">
			            Rango CAF AFECTO
			          </th>
			          <th class="text-left">
			            Último folio AFECTO emitido
			          </th>
			          <th class="text-left">
			            Rango CAF EXENTO
			          </th>
			          <th class="text-left">
			            Último folio EXENTO emitido
			          </th>
			        </tr>
			      </thead>
			      <tbody>
			        <tr>
			          <td>{{ dispositivo.id_dispositivo }}</td>
			          <td>{{ dispositivo.os }}</td>
			          <td>{{ dispositivo.rango_afecto }}</td>
			          <td>{{ (dispositivo.folio_afecto == -1 ? "" : dispositivo.folio_afecto) }}</td>
			          <td>{{ dispositivo.rango_exento }}</td>
			          <td>{{ (dispositivo.folio_exento == -1 ? "" : dispositivo.folio_exento) }}</td>
			        </tr>
			      </tbody>
			    </template>
			</v-simple-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
          	absolute
          	left
          	bottom
            color="success"
            @click="cerrarModal"
          >
            No, no deseo DESHABILITAR el dispositivo
          </v-btn>
          <v-btn
          	absolute
          	right
          	bottom
            color="error"
            @click="deshabilitarDispositivo"
          >
            Sí, deseo DESHABILITAR el dispositivo
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>

export default {
	name: 'ModalDeshabilitar',
	data () {
		return {
			openDialog:false,
			dispositivo:{
				id_dispositivo: "",
				os: "",
				rango_afecto: "",
				folio_afecto:"",
				rango_exento: "",
				folio_exento: ""
			}
		}
	},
	methods:{
		cerrarModal: function(){
			this.openDialog=false;
		},
		deshabilitarDispositivo: function(){
			this.openDialog=false;
			this.$emit('deshabilitar',this.dispositivo.id_dispositivo);
		}
	}
}
</script>

<style lang="css" scoped>
</style>